<template>
	<div class="swatches" :class="input.class">
		<div class="swatch" v-for="(selection,i) in input.selections" :key="i">
			<input type="radio" v-model="value" :name="input.name" :value="selection.value" :id="getSwatchId(selection)" />
			<label :for="getSwatchId(selection)">
				<template v-if="selection.color || selection.image">
					<div class="swatch-image">
						<span v-if="selection.image" :style="getBackgroundColor(selection.color)">
							<img class="swatch-picture" :src="selection.image" :alt="selection.name" />
						</span>
						<canvas class="swatch-color" v-else :style="getBackgroundColor(selection.color)"></canvas>
					</div>
					<div class="swatch-name">
						<span v-text="selection.name"></span>
					</div>
				</template>
				<template v-else>
					<div class="swatch-text">{{selection.name}}</div>
				</template>
				<div class="swatch-price">{{formatPrice(selection.price)}}</div>
			</label>
		</div>
	</div>
</template>

<script>
import helper from "@/mixins/helper.js";
import InputBase from "./InputBase";

export default {
	name: "InputSwatch",
	extends: InputBase,
	data: function() {
		return {
			input: this.option.input,
			value: this.option.input.default
		};
	},
	props: ["option"],
	mixins: [helper],
	watch: {
		// Save value to store when changed
		// Save updated Option validation status to store on change
		value: function() {
			this.saveToStore();
			this.updateValidationStatus(this.option, this.value);
		}
	},
	created: function() {
		// Save default value to store
		if (this.value) {
			this.saveToStore();
		}
		// Save default validation status to store
		this.updateValidationStatus(this.option, this.value);
	},
	computed: {
		selectedSwatch: function() {
			let self = this;
			return this.input.selections.filter(function(swatch) {
				return swatch.value === self.value;
			})[0];
		}
	},
	methods: {
		getBackgroundColor(color) {
			return color ? "background-color: " + color + ";" : "";
		},
		saveToStore: function() {
			this.setSelectedOptionToStore(this.input.name, {
				name: this.option.name + ": " + this.selectedSwatch.name,
				price: this.selectedSwatch.price,
				sku: this.selectedSwatch.sku,
				position: this.option.position,
				value: this.value,
				previewValue: this.selectedSwatch.previewValue,
				previewMutations: this.option.previewMutations
			});
		},
		getSwatchId: function(selection) {
			let val = selection.value || "null";
			return this.input.name + "-" + val;
		}
	}
};
</script>

<style lang="scss">
.swatches {
	display: flex;
	overflow-x: auto;
	padding-bottom: 16px;

	.swatch {
		min-width: 96px;
		max-width: 110px;
		width: 100%;
		position: relative;

		&:first-of-type {
			margin-left: auto;
		}
		&:last-of-type {
			margin-right: auto;
		}

		> input[type="radio"] {
			display: none;

			&:checked + label .swatch-image,
			&:checked + label .swatch-text {
				outline: 3px solid $color-martinique-blue;
				border-color: #fff;
				background-color: #fff;
			}
		}

		label {
			display: block;
			padding: 3px;
			width: 100%;
			cursor: pointer;
			text-align: center;
			word-break: break-word;
			hyphens: auto;

			.swatch-image,
			.swatch-text {
				margin: 0 auto 16px;
				text-align: center;
				border: 2px solid #dadada;
				background-color: #f9f9f9;
				font-size: 0;
				width: 18vw;
				height: 18vw;
				max-width: 74px;
				max-height: 74px;
				overflow: hidden;
				display: flex;
				align-items: center;
				justify-content: center;

				.swatch-picture {
					width: 100%;
					max-width: 70px;
				}
				.swatch-color {
					width: 100%;
					height: 100%;
				}
			}

			.swatch-text {
				padding: 8px;
				font-size: 1.2em;
				font-weight: bold;
				text-align: center;
				min-width: 74px;
			}

			.swatch-name {
				margin-bottom: 8px;
				font-weight: bold;
			}
		}
	}

	// Scrollbar
	&::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}
	&::-webkit-scrollbar-track {
		background: $color-athens-grey;
		opacity: 1;
	}
	&::-webkit-scrollbar-thumb {
		background: grey;
		opacity: 1;
	}

	@media only screen and (min-width: $viewport-desktop) {
		flex-wrap: wrap;
		justify-content: center;

		.swatch {
			margin-bottom: 16px;
			&:first-of-type {
				margin-left: 0;
			}
			&:last-of-type {
				margin-right: 0;
			}
		}
	}
}
</style>